// 修饰键在 Mac 上是 ⌘，在 Windows / Linux 上是 Ctrl。
//
// **行为一直是对的** —— 全站三个 handler 写的都是 `metaKey || ctrlKey`，两边都收。
// 错的是显示出来的那个字：在这之前全前端零平台判断，键帽、title、aria-label 全写死
// ⌘，于是 Windows 用户在 wiki 左栏、待办左栏和整个「快捷键和写法」面板里看到的每一个
// 快捷键都按不出来。这个模块就是那个字的唯一出处。

type UADataNavigator = Navigator & { userAgentData?: { platform?: string } };

function detectMac(): boolean {
  // SSR / 给爬虫的静态 HTML：拿不到 navigator。Ctrl 是更保守的默认值。
  if (typeof navigator === 'undefined') return false;

  // userAgentData 是这三个里唯一没被废弃的，但只有 Chromium 有它。
  const reported = (navigator as UADataNavigator).userAgentData?.platform;
  if (reported) return reported === 'macOS';

  // navigator.platform 标了废弃，却没有任何浏览器真的移除 —— Safari 和
  // Firefox 还得靠它，所以它排在 userAgent 之前。
  return /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);
}

export const IS_MAC: boolean = detectMac();

/** 键帽上那个字：`<kbd>{MOD_KEY}</kbd>`。 */
export const MOD_KEY: '⌘' | 'Ctrl' = IS_MAC ? '⌘' : 'Ctrl';

/** 写进整句话里的版本（title / aria-label）：`⌘J` 能连写，`CtrlJ` 不行。 */
export const MOD_LABEL: '⌘' | 'Ctrl+' = IS_MAC ? '⌘' : 'Ctrl+';

// 没有键盘的设备上，键帽是假信息 —— 那台机器根本没有这个键。
// 这一行原来在 InputCenter.tsx 里，搬过来是因为顶栏也要用它决定那枚收起入口
// 显不显示键帽，而 InputCenter 是个 lazy chunk，顶栏不该为这一个布尔值把它拖进首屏。
export const IS_TOUCH: boolean =
  typeof window !== 'undefined' && Boolean(window.matchMedia?.('(pointer: coarse)').matches);
